import {
  ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__REQUEST,
  ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__SUCCESS,
  ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__REQUEST:
    case ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__SUCCESS:
      return null;

    case ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
